import { createReducer } from "@reduxjs/toolkit"
import { getSize } from "@components/Canvas/hooks/useSizes"
import { EditType, PageSize, BadgeSize, PageOption, TemplateType } from "@store/reducers/init/types"
import {
  changeBadgeMargins,
  changeCalculatedGridSize,
  changeCurrentDesign,
  changeCustomFormatInputMode,
  changeCustomGridSize,
  changeCustomPageSizeInputMode,
  changeEditType,
  changeEnabledModules,
  changeFormatSize,
  changeIsAddOnBadge,
  changeNeedConfirmation,
  changePageData,
  changePageOption,
  changePageSize,
  changePageSizes,
  changePaperMargins,
  changePaperType,
  changeSelectedPage,
  changeSelectedTags,
  changeThirdPartyFormat,
  changeThirdPartyName,
  changeThirdPartySettings,
  changeUnitType,
  rerenderGrid,
  resetCanvas,
  resetState,
  updatePageData,
  changeSeperatePage, changeTemplateType, changeIsFloorMap, changeShowBackgroundImage, changeIsAttendeeFloorMap,
  setBoothColorSetting,
  changeIsTableFinder, changeAttendees,
  changeTableDataGlobal,
  changeSponsorLogos, changeSelectedPageIndex,
  changeShowBoothRegistration
} from "./actions"
import { initialPaperState } from "./consts"
import cloneDeep from "lodash/cloneDeep"
import { isBoolean } from "lodash"

function formatPageSize(width: number, height: number): PageSize {
  return {
    width: width,
    height: height,
    name: "",
  }
}

function loadCanvasSettings(state, options) {
  console.log("loadCanvasSettings", options)
  state.thirdPartyFormat = initialPaperState.thirdPartyFormat
  state.thirdPartyName = initialPaperState.thirdPartyName
  state.isCustomFormatSizeMode = initialPaperState.isCustomFormatSizeMode
  state.isCustomPageSizeMode = initialPaperState.isCustomPageSizeMode

  state.pageData = options.pageData || initialPaperState.pageData
  state.pageOption = options.pageOption || initialPaperState.pageOption
  state.seperatePages = options.seperatePages || initialPaperState.seperatePages
  state.enabledModules = options.modules || []
  state.thirdParty = options.isThirdParty || initialPaperState.thirdParty
  state.editType = options.editType || initialPaperState.editType
  state.layout = options.layout || initialPaperState.layout
  state.selectedTags = options.selectedTags || initialPaperState.selectedTags
  state.isAddOnBadge = options.isAddOnBadge || initialPaperState.isAddOnBadge
  state.templateType = options.component_type || initialPaperState.templateType
  state.boothColorSetting = options.boothColorSetting || initialPaperState.boothColorSetting
  state.showBoothRegistration = options.showBoothRegistration ?? true
  state.selectedPage = 0
  state.canvasReset = state.canvasReset + 1
  state.sponsorLogos = options.sponsorLogos || []
  //Additional processing.
  setPageOption(state)
  let badgeSize = options.badgeSize
  setFormatSize(state, badgeSize || initialPaperState.selectedFormat)
  setPageSize(state, options.pageSize || initialPaperState.pageSize)

  if (options.isThirdParty) {
    console.log("load third party settings", options.thirdPartyOptions)
    setThirdPartyFormat(state, options.thirdPartyOptions, options.isThirdParty, options)
    state.thirdPartyName = options.thirdPartyOptions.Product__c
  } else {
    state.thirdPartyFormat = initialPaperState.thirdPartyFormat
    state.thirdPartyName = initialPaperState.thirdPartyName
  }

  if (options?.layout?.gridSizes?.rows) {
    // state.layout.gridSizes = { custom: options.layout.gridSizes, calculated: options.layout.gridSizes }
    state.layout.gridSizes = { calculated: options.layout.gridSizes }
  }

  if(options?.tableDataGlobal?.statusColors){
    state.tableDataGlobal.statusColors = options.tableDataGlobal.statusColors
  }
}

function setPageOption(state, { updatePageSizes } = { updatePageSizes: false }) {
  switch (state.pageOption) {
    case PageOption.SINGLE:
      state.pageData.splice(1)
      state.selectedPage = 0
      break
    case PageOption.MULTI:
      if (state.pageData.length < 2) {
        state.pageData.push(initialPaperState.pageData[1])
      }
      //now we the pageOption is double, we need to convert it to multi page.
      state.pageOption = PageOption.MULTI
      console.log("state.pageData.length", state.pageData.length)
      //Rename first and second page as front and back side.
      // state.pageData[0].pageLabel = "Front Side"

      // //remove the rest of the pages.
      // state.pageData.splice(2)
      // if (state.selectedPage > 1) {
      //   state.selectedPage = 0
      // }
      break
  }

  if (updatePageSizes) {
    let factor = state.seperatePages ? 1 : state.pageData.length
    setPageSize(state, { width: state.selectedFormat.width, height: state.selectedFormat.height * factor })
  }
}

function setThirdPartyFormat(state, data, enabled = true, opt = null) {
  opt = opt || {}
  state.thirdParty = enabled
  state.thirdPartyFormat = data
  let template = data
  if (template) {
    // console.log("thirdparty", state)

    let fSize = { width: template.Badge_Width__c, height: template.Badge_Height__c }
    if (template.isContinuous) {
      console.log("saru", opt)
      //Continuous papers don't have a fixed width. We're using previous width.
      fSize.width = fSize.width || state.selectedFormat.width

      fSize.height = (opt && opt.pageSize?.height) || fSize?.height || state.selectedFormat.height
    }
    setPageSize(state, formatPageSize(template.Paper_Width__c, template.Paper_Height__c))
    setFormatSize(state, formatPageSize(fSize.width, fSize.height))
  }
}

function setFormatSize(state, payload) {
  let size = getSize(payload, state.formats, state.unitType)
  if (size.isCustom) {
    state.formats[size.name] = size
  }
  state.selectedFormat = size
  state.isCustomFormatSizeMode = false
  state.needConfirmation = true
  console.log("selectedFormat", state.selectedFormat)
}

function setPageSize(state, payload) {
  let size = getSize(payload, state.pageSizes, state.unitType)
  if (size.isCustom) {
    state.pageSizes[size.name] = size
  }
  state.pageSize = size
  state.isCustomPageSizeMode = false
  state.needConfirmation = true
}

function resetLayoutMargins(state) {
  state.layout.badgeMargins = { right: 0, bottom: 0 }
  state.layout.pageMargins = { top: 0, bottom: 0, left: 0, right: 0, centerH: true, centerV: true }
}

export const paperReducer = createReducer(initialPaperState, (builder) => {
  builder.addCase(changeTemplateType, (state, { payload }: { payload: TemplateType }) => {
    state.templateType = payload
  });

  builder.addCase(changeEditType, (state, { payload }: { payload: EditType }) => {
    console.log(payload)
    state.editType = payload
  })

  builder.addCase(changeNeedConfirmation, (state, { payload }) => {
    //@ts-ignore
    state.needConfirmation = payload
  })

  builder.addCase(changeCurrentDesign, (state, { payload }) => {
    let { template = {}, editType } = payload || {}
    state.currentDesignId = template.id

    let {
      template: { options, modules, pageData },
      component_type
    } = template

    loadCanvasSettings(state, { ...options, component_type, editType, modules: template.modules, pageData })
  })

  builder.addCase(resetCanvas, (state, { payload }) => {
    loadCanvasSettings(state, payload)
  })

  builder.addCase(changeUnitType, (state, { payload }) => {
    //@ts-ignore
    state.unitType = payload
  })

  builder.addCase(changeThirdPartySettings, (state, { payload }) => {
    state.thirdParty = payload
  })

  builder.addCase(changeFormatSize, (state, { payload }: { payload: BadgeSize }) => {
    console.log("customStoreChange first",payload)
    setFormatSize(state, payload)
    // set the page size to the same as the format size
    // setDoubleOption will set the page size to double the format size if double sided is selected
    setPageOption(state, { updatePageSizes: true })
  })

  builder.addCase(changePageOption, (state, { payload }) => {
    state.pageOption = payload
    setPageOption(state, { updatePageSizes: true })
  })

  builder.addCase(changeSeperatePage, (state, action) => {
    const payload = action.payload
    console.log("changeSeparatePage", payload)
    //@ts-ignore
    state.seperatePages = payload
    setPageOption(state, { updatePageSizes: true })
  })
  //ThirdParty Format
  builder.addCase(changeThirdPartyFormat, (state, { payload }) => {
    //@ts-ignore
    setThirdPartyFormat(state, payload)
  })

  //ThirdParty Name
  builder.addCase(changeThirdPartyName, (state, { payload }) => {
    //@ts-ignore
    state.thirdPartyName = payload
  })
  //Layout
  builder.addCase(changePaperMargins, (state, { payload }) => {
    state.layout.pageMargins = payload
  })

  builder.addCase(changeCustomPageSizeInputMode, (state, { payload }) => {
    state.isCustomPageSizeMode = true
  })

  builder.addCase(changePageSize, (state, { payload }) => {
    setPageSize(state, payload)
  })

  builder.addCase(changePageSizes, (state, { payload }) => {
    console.log("getting pagesize", payload)
    state.pageSizes = payload
  })

  builder.addCase(changeBadgeMargins, (state, { payload }) => {
    state.layout.badgeMargins = payload
  })
  builder.addCase(changeCalculatedGridSize, (state, { payload }) => {
    if (
      state.layout.gridSizes.calculated.columns !== payload.columns ||
      state.layout.gridSizes.calculated.rows !== payload.rows
    ) {
      state.layout.gridSizes.calculated = payload
    }
  })
  builder.addCase(changeCustomGridSize, (state, { payload: gridSize }) => {
    let { calculated } = state.layout.gridSizes

    //don't allow custom grid size to be greater than calculated grid size
    state.layout.gridSizes.custom = {
      columns: Math.min(gridSize.columns, calculated.columns),
      rows: Math.min(gridSize.rows, calculated.rows),
    }
  })

  builder.addCase(changePaperType, (state, { payload }) => {
    state.layout.type = payload
    state.layout.gridSizes = { custom: undefined, calculated: { columns: 1, rows: 1 } }

    setThirdPartyFormat(state, null, payload === "template")

    resetLayoutMargins(state)
    state.needConfirmation = true
  })

  builder.addCase(changeCustomFormatInputMode, (state, { payload }) => {
    state.isCustomFormatSizeMode = true
  })

  builder.addCase(changeEnabledModules, (state, { payload }) => {
    state.enabledModules = payload
    state.needConfirmation = true
  })
  builder.addCase(resetState, (state, { payload }) => {
    return { ...cloneDeep(initialPaperState), canvasReset: state.canvasReset }
  })
  //Page data
  builder.addCase(changeSelectedPage, (state, { payload }) => {
    state.selectedPage = payload
  })
  builder.addCase(changePageData, (state, { payload }) => {
    state.pageData = payload || [...initialPaperState.pageData]
  })
  builder.addCase(updatePageData, (state, { payload }) => {
    state.pageData = payload || [...initialPaperState.pageData]
  })
  builder.addCase(rerenderGrid, (state, { payload }) => {
    state.gridUpdateCounter = state.gridUpdateCounter + 1
  })
  builder.addCase(changeIsAddOnBadge, (state, { payload }) => {
    state.isAddOnBadge = payload
    state.needConfirmation = true
  })
  builder.addCase(changeSelectedTags, (state, { payload }) => {
    state.selectedTags = payload
    state.needConfirmation = true
  })

  builder.addCase(changeIsFloorMap, (state, { payload }) => {
    state.isFloorMap = payload
  })
  builder.addCase(changeIsAttendeeFloorMap, (state, { payload }) => {
    state.isAttendeeFloorMap = payload
  })
  builder.addCase(changeShowBackgroundImage, (state, { payload }) => {
    state.showBackgroundImage = payload
  })
  builder.addCase(setBoothColorSetting, (state, { payload }) => {
    state.boothColorSetting = payload
  })
  builder.addCase(changeAttendees, (state, { payload }) => {
    state.attendees = payload
  })
  builder.addCase(changeTableDataGlobal, (state, { payload }) => {
    state.tableDataGlobal = payload
  })
  builder.addCase(changeIsTableFinder, (state, { payload }) => {
    state.isTableFinder = payload
  })
  builder.addCase(changeSponsorLogos, (state, {payload})=>{ 
    //@ts-ignore
    state.sponsorLogos = payload
  })
  builder.addCase(changeShowBoothRegistration, (state, {payload})=>{
    //@ts-ignore
    state.showBoothRegistration = payload
  })
                                          builder.addCase(changeSelectedPageIndex, (state, { payload }) => {
                                                          state.selectedPageIndex = payload
                                                          })
})


